import React from 'react'
import { useTheme } from '@mui/material/styles'
import styled from 'styled-components'
import Chip from '@mui/material/Chip'
import Typography from '@/v2/components/common/Typography'
import ConversationActions from './ConversationActions'
import PatientAvatar from '@/v2/components/common/PatientAvatar'
import { formatPhone } from '@/v2/utils/format'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.primary.main};
  height: 80px;
  flex-shrink: 0;

  @media (max-width: 1200px) {
    padding: 8px 12px;
    height: 70px;
  }
`

const PatientsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  overflow: hidden;
`

const PatientInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 12px;
  min-width: 0;

  @media (max-width: 1200px) {
    margin-right: 8px;
  }
`

const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: 12px;
  flex-shrink: 0;

  @media (max-width: 1200px) {
    margin-left: 8px;
  }
`

const PatientHeader = ({ patients = [], conversation }) => {
  const theme = useTheme()
  return (
    <Wrapper theme={theme.palette}>
      <PatientsWrapper>
        {!!patients.length ? (
          <>
            {patients.map((patient, idx) => (
              <PatientInfo key={patient.id || idx}>
                <PatientAvatar
                  patient={patient}
                  size={36}
                  sx={{
                    width: 36,
                    height: 36,
                    marginBottom: '4px',
                    flexShrink: 0,
                  }}
                />
                <Typography
                  fontSize="16px"
                  variant="h2"
                  sx={{
                    margin: 0,
                    marginTop: '4px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '150px',
                  }}
                >
                  {patient.fullName || formatPhone(patient.phoneNumber)}
                </Typography>
              </PatientInfo>
            ))}
          </>
        ) : (
          <PatientInfo>
            <PatientAvatar
              patient={{
                phoneNumber: conversation.phoneNumber,
              }}
              size={36}
              sx={{ width: 36, height: 36, marginBottom: '4px', flexShrink: 0 }}
            />
            <Typography
              fontSize="16px"
              variant="h2"
              sx={{
                margin: 0,
                marginTop: '4px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '150px',
              }}
            >
              {formatPhone(conversation.phoneNumber)}
            </Typography>
          </PatientInfo>
        )}
      </PatientsWrapper>
      <Chip
        label={conversation.open ? 'Open' : 'Closed'}
        sx={{ marginLeft: '4px' }}
      />
      <RightSection>
        {!!conversation && <ConversationActions conversation={conversation} />}
      </RightSection>
    </Wrapper>
  )
}

export default PatientHeader
